import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      titleIcon: string;
      title: string;
      message: string;
      confirmText: string;
      cancelButton: string;
      hideCancelBtn?: boolean;
      hideCloseBtn?: boolean;
      disableClose?: boolean;
      /**
       * When true, renders the confirm button as the dominant/primary action and the
       * cancel button as a low-emphasis action. Opt-in only — omitted/false keeps every
       * existing consumer's appearance unchanged.
       */
      emphasizeConfirm?: boolean;
    } = {} as any
  ) {
    // Desabilita o fechamento do modal com ESC se disableClose for true
    if (this.data.disableClose) {
      this.dialogRef.disableClose = true;
    }
  }

  onConfirm() {
    this.dialogRef.close(true);
  }
  
  onDismiss() {
    this.dialogRef.close(false);
  }
  
  onCancel() {
    this.dialogRef.close(null);
  }
}
